export default {"src":"/_next/static/media/Left Wrapper.be2e3c44.svg","height":48,"width":219,"blurWidth":0,"blurHeight":0};